<template>
	<div >
		<layout-4 :id=pageid :term=term :path="'0307'" :overview=true style="width:100%; height:calc(100vh - 50px);"></layout-4>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.EMPLOYEE_OVERVIEW_PAGE,
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Employee_Overview.vue